import Admin from "../Admin";
import React from "react";
import CardAdminDepartmentList from "../../../Component/Card/Admin/Department/CardAdminDepartmentList";
import PageHeader from "../../../Component/PageHeader";
import MUIButton from "@mui/material/Button";
import MUIAddIcon from "@mui/icons-material/Add";

export default class AdminDepartmentList extends Admin {
  /**
   * Render the content.
   */
  renderContent() {
    return <CardAdminDepartmentList />;
  }

  /**
   * Render the header.
   */
  renderHeader() {
    const handleClickCreate = () => {
      this.props.history.push({
        pathname: "/admin/department",
      });
    };

    const buttons = [
      <MUIButton
        component="label"
        variant="contained"
        startIcon={<MUIAddIcon />}
        onClick={handleClickCreate}
      >
        Create New
      </MUIButton>,
    ];

    return <PageHeader title="Departments" buttons={buttons} />;
  }
}
